import React from 'react';
import ManCrossPageFooter from '../components/ManCrossPageFooter';

const ManCrossPagePlanGroup = ({ reportData, headerText, pageNumber }) => {
    const payload = reportData?.payload || {};
    const planes  = payload.planes || [];

    return (
        <div className="mgcr-drivers-page">
            <div className="mgcr-page-header">
                <span className="mgcr-page-header-text">{headerText}</span>
                <span className="mgcr-page-header-num">{pageNumber}</span>
            </div>

            <div className="keep-blankspace" />

            <div className="mgcr-dx-title-area">
                <h2 className="mgcr-dx-main-title">Plan Diferenciado por Grupo de Riesgo</h2>
                <p className="mgcr-dx-subtitle">Agenda de Intervención</p>
            </div>

            <div className="mgcr-roi-callout">
                El plan no es genérico — sale de sus datos. Tres tipos de riesgo. Tres planes distintos.
            </div>

            {planes.length === 0 ? (
                <div className="mgcr-drivers-empty-state">
                    <div className="mgcr-drivers-empty-title">Sin grupos de riesgo activo</div>
                    <div className="mgcr-drivers-empty-text">
                        No hay áreas con IVC activo. Todas las áreas están en Riesgo Bajo.
                    </div>
                </div>
            ) : (
                <div className="mgcr-plan-groups">
                    {planes.map((plan) => (
                        <div key={plan.grupo} className="mgcr-plan-group">
                            {/* Header del grupo */}
                            <div
                                className="mgcr-plan-group-header"
                                style={{ backgroundColor: plan.color }}
                            >
                                <span className="mgcr-plan-group-title">{plan.grupo_nombre}</span>
                                <span className="mgcr-plan-group-areas">
                                    {plan.areas && plan.areas.length > 0
                                        ? `Áreas: ${plan.areas.join(' · ')}`
                                        : ''}
                                </span>
                            </div>

                            {/* Tabla de acciones */}
                            <table className="mgcr-plan-table">
                                <thead>
                                    <tr className="mgcr-plan-thead-row">
                                        <th className="mgcr-plan-th mgcr-plan-th--actor">Actor</th>
                                        <th className="mgcr-plan-th mgcr-plan-th--accion">Acción</th>
                                        <th className="mgcr-plan-th mgcr-plan-th--plazo">Plazo</th>
                                        <th className="mgcr-plan-th mgcr-plan-th--kpi">KPI</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(plan.acciones || []).map((acc, i) => (
                                        <tr key={i} className="mgcr-plan-row">
                                            <td className="mgcr-plan-td mgcr-plan-td--actor">
                                                {acc.actor}
                                            </td>
                                            <td className="mgcr-plan-td mgcr-plan-td--accion">
                                                {acc.accion}
                                            </td>
                                            <td className="mgcr-plan-td mgcr-plan-td--plazo">
                                                <span
                                                    className="mgcr-plan-plazo-badge"
                                                    style={{ backgroundColor: acc.plazo_color }}
                                                >
                                                    {acc.plazo}
                                                </span>
                                            </td>
                                            <td className="mgcr-plan-td mgcr-plan-td--kpi">
                                                {acc.kpi}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ))}
                </div>
            )}

            <div className="keep-blankspace" />
            <ManCrossPageFooter />
        </div>
    );
};

export default ManCrossPagePlanGroup;
